// 🔒 PROTECTED — PricePAL Compare
// Owner: Garry Yee | Do not modify without explicit written permission
// See /app/PROTECTED_CODE_REGISTRY.md for full rules
import React, { useState, useEffect, useCallback } from 'react';

/**
 * Accessibility Live Region
 * Announces route changes and dynamic updates to screen readers.
 * Renders a visually hidden ARIA live region.
 */

let announceCallback = null;

// Global announce function - call from anywhere
export const announce = (message, priority = 'polite') => {
  if (announceCallback) {
    announceCallback(message, priority);
  }
};

const A11yLiveRegion = () => {
  const [politeMessage, setPoliteMessage] = useState('');
  const [assertiveMessage, setAssertiveMessage] = useState('');

  const handleAnnounce = useCallback((message, priority) => {
    if (priority === 'assertive') {
      setAssertiveMessage('');
      setTimeout(() => setAssertiveMessage(message), 100);
    } else {
      setPoliteMessage('');
      setTimeout(() => setPoliteMessage(message), 100);
    }
  }, []);

  useEffect(() => {
    announceCallback = handleAnnounce;
    return () => { announceCallback = null; };
  }, [handleAnnounce]);

  return (
    <>
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {politeMessage}
      </div>
      <div
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      >
        {assertiveMessage}
      </div>
    </>
  );
};

export default A11yLiveRegion;
